import React, { useCallback, useMemo } from 'react';
import { Route, useHistory, useLocation, Switch, Redirect } from 'react-router-dom';

import withAuthentication from 'Components/withAuthentication';
import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import TabMobileBuildsList from './components/TabMobileBuildsList/index';
import MobileBuildsDetails from './components/MobileBuildDetails/MobileBuildDetails';
import ReactGA from 'Shared/analytics';
import useDocumentTitle from 'Shared/hooks/useDocumentTitle';

const getTabs = (projects) => {
  return projects.map((project) => {
    return {
      id: project.id,
      label: project.title,
    };
  });
};
const MobileBuilds = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const projects =
    profileData && profileData.user.employeeprofile && profileData.user.employeeprofile.mobileProjects.length > 0
      ? profileData && profileData.user.employeeprofile.mobileProjects
      : [];

  const tabRouter = (
    <>
      <Route
        path="/employee/mobile-builds/"
        exact
        render={() => (
          <Redirect
            to={
              projects.length > 0 ? `/employee/mobile-builds/${projects[0]?.id}/` : '/employee/vacations/leave-request/'
            }
          />
        )}
      />
      <Switch>
        <Route path="/employee/mobile-builds/:id" component={TabMobileBuildsList} />
        <Route path="/employee/builds/:publicHash" component={MobileBuildsDetails} />
      </Switch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3] || projects[0]?.id;
  }, [pathname, projects]);

  let pageTitle = 'Mobile builds';
  if (projects.length > 0) {
    pageTitle = `Mobile builds - ${projects.find(({ id }) => +id === +activeTabId)?.title || activeTabId}`;
  }
  useDocumentTitle(pageTitle);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== pathname.split('/')[2]) {
        history.push(`/employee/mobile-builds/${tabClicked}/`);
        window.localStorage.setItem('lastProject', tabClicked);
        ReactGA.pageview(`/employee/mobile-builds/${tabClicked}/`, 'mobile-builds' + tabClicked);
      }
    },
    [pathname, history]
  );

  const handleBackToList = useCallback(() => {
    const lastProject = window.localStorage.getItem('lastProject') || projects[0].id;
    history.push(`/employee/mobile-builds/${lastProject}/`);
  }, [projects, history]);

  const getNavigation = () => {
    if (pathname.includes('mobile-builds')) {
      return {
        variant: 'tabs',
        tabsProps: {
          tabs: getTabs(projects),
          onTabClick: handleTabClick,
          activeTabId,
        },
      };
    } else {
      return {
        variant: 'tabs',
        tabsProps: {
          tabs: [{ id: 'backToList', label: '< BACK TO LIST' }],
          onTabClick: handleBackToList,
        },
      };
    }
  };

  return (
    <>
      <Page
        props={{
          className: 'mobile-builds-tab',
          titleProps: { text: 'Mobile builds' },
          navigation: getNavigation(),
          navbarProps: { points: navbarReduce(profileData) },
          content: tabRouter,
        }}
      />
    </>
  );
};

export default withAuthentication(MobileBuilds);
